import i18next from 'i18next';

export default i18next;



// WEBPACK FOOTER //
// /~/eoxc/src/i18next.js